/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
import React from 'react';
import cx from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import Content from '../../atoms/Content';
import PropertyControlledComponent from '../../molecules/PropertyControlledComponent';
import Select from '../../molecules/Select';
import PaginationButton from '../Pagination/_paginationButton';
import PaginationLink from '../Pagination/_paginationLink';
import './pagination.scss';
var TokenPagination = function TokenPagination(props) {
  var currentPage = props.currentPage,
    initialFetchDone = props.initialFetchDone,
    displayFirst = props.displayFirst,
    isLoading = props.isLoading,
    resultsPerPage = props.resultsPerPage,
    changePage = props.changePage,
    canSetResultsPerPage = props.canSetResultsPerPage,
    resultsPerPageOptions = props.resultsPerPageOptions,
    fixedPagination = props.fixedPagination,
    className = props.className,
    nextPageToken = props.nextPageToken;
  var setTokenPage = function setTokenPage(res) {
    return function (page) {
      changePage({
        page: page,
        resultsPerPage: res
      });
    };
  };
  var setResultsPerPage = function setResultsPerPage(res) {
    setTokenPage(res)(currentPage);
  };
  var getPaginationButtonProps = function getPaginationButtonProps() {
    var isFirstPrevButtonsDisabled = currentPage <= 1 || isLoading;
    var isNextButtonsDisabled = _isEmpty(nextPageToken) || isLoading;
    return {
      isFirstPrevButtonsDisabled: isFirstPrevButtonsDisabled,
      isNextButtonsDisabled: isNextButtonsDisabled
    };
  };
  var _getPaginationButtonP = getPaginationButtonProps(currentPage, nextPageToken, isLoading),
    isFirstPrevButtonsDisabled = _getPaginationButtonP.isFirstPrevButtonsDisabled,
    isNextButtonsDisabled = _getPaginationButtonP.isNextButtonsDisabled;
  var shouldDisplayFirst = displayFirst && currentPage > 1;
  if (!initialFetchDone) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pagination is-loading"
    });
  }
  var resultsPerPageSelectOptions = resultsPerPageOptions.map(function (resultsPerPageOption) {
    return {
      label: resultsPerPageOption,
      value: resultsPerPageOption
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cx('pagination', {
      'stick-pagination-component': fixedPagination
    }, className)
  }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: canSetResultsPerPage
  }, /*#__PURE__*/React.createElement("div", {
    className: "pagination__results-per-page"
  }, /*#__PURE__*/React.createElement(Select, {
    config: {
      label: 'label',
      value: 'value'
    },
    onChange: setResultsPerPage,
    value: resultsPerPage,
    options: resultsPerPageSelectOptions,
    defaultValue: resultsPerPage
  }), /*#__PURE__*/React.createElement(Content, {
    className: "pagination__results-per-page__title"
  }, __('Results Per Page')), /*#__PURE__*/React.createElement("div", {
    className: "pagination__results-per-page__divider"
  }))), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: shouldDisplayFirst
  }, /*#__PURE__*/React.createElement(PaginationButton, {
    changePage: setTokenPage(resultsPerPage),
    pageNumber: 1,
    isDisabled: isFirstPrevButtonsDisabled,
    buttonText: __('First'),
    isJumpButton: true,
    hasLeftIcon: true
  })), /*#__PURE__*/React.createElement(PaginationButton, {
    changePage: setTokenPage(resultsPerPage),
    pageNumber: currentPage - 1,
    isDisabled: isFirstPrevButtonsDisabled,
    buttonText: __('Prev'),
    isJumpButton: true,
    hasLeftIcon: true
  }), /*#__PURE__*/React.createElement(PaginationLink, {
    changePage: setTokenPage(resultsPerPage),
    pageNumber: currentPage,
    isDisabled: isLoading,
    isActive: true
  }), /*#__PURE__*/React.createElement(PaginationButton, {
    changePage: setTokenPage(resultsPerPage),
    pageNumber: currentPage + 1,
    isDisabled: isNextButtonsDisabled,
    buttonText: __('Next'),
    isJumpButton: true,
    hasLeftIcon: false
  }));
};
TokenPagination.defaultProps = {
  currentPage: 1,
  initialFetchDone: true,
  isLoading: false,
  displayFirst: true,
  canSetResultsPerPage: true,
  resultsPerPage: 50,
  resultsPerPageOptions: [50, 100, 150, 200],
  fixedPagination: false,
  className: PropTypes.string
};
TokenPagination.propTypes = {
  currentPage: PropTypes.number,
  initialFetchDone: PropTypes.bool,
  isLoading: PropTypes.bool,
  displayFirst: PropTypes.bool,
  resultsPerPage: PropTypes.number,
  canSetResultsPerPage: PropTypes.bool,
  changePage: PropTypes.func.isRequired,
  resultsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  fixedPagination: PropTypes.bool,
  className: ''
};
export default TokenPagination;